<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Base>
    <template v-slot:content>
      <div v-if="contract && contract.deletedAt" class="bg-danger py-10 fs-2x text-white text-center">
        Ce contrat a été supprimé
      </div>
      <div v-if="contractNotFound" class="w-100 p-10 d-flex justify-content-center align-items-center">
        <i class="fad fa-empty-set fs-5x"></i>
        <div>Ce Contrat n'existe plus</div>
      </div>
      <div v-else-if="old">
        Ce contrat n'a pas encore été converti
      </div>
      <div v-else class="d-flex flex-column gap-10">
        <div v-if="!contract && mergedTo" class="card">
          <div class="card-body">
            <div class="alert alert-warning d-flex align-items-center justify-content-between mb-0">
              <div>
                <i class="fad fa-triangle-exclamation me-2"></i>
                <b>Contrat mergé</b> — Ce contrat a été fusionné. Ouvrez le master pour accéder aux données.
              </div>
              <div class="d-flex gap-2">
                <router-link v-if="hasRole('ROLE_MANAGER') || hasRole('ROLE_ADMIN')" :to="{name:'contract-show', params:{contractUuid: mergedTo}}" class="btn btn-warning">
                  <i class="fad fa-arrow-right me-1"></i>
                  Ouvrir le master
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card ">
          <div v-if="contract" class="card-body pt-9 pb-0 d-flex flex-column">
            <div v-if="mergedTo" class="alert alert-warning d-flex align-items-center justify-content-between mb-5">
              <div>
                <i class="fad fa-triangle-exclamation me-2"></i>
                <b>Contrat mergé à tort</b> — Les avenants et actifs de ce contrat ont été rapatriés sur un autre contrat master.
              </div>
              <div class="d-flex gap-2">
                <router-link v-if="hasRole('ROLE_MANAGER') || hasRole('ROLE_ADMIN')" :to="{name:'contract-show', params:{contractUuid: mergedTo}}" class="btn btn-warning">
                  <i class="fad fa-arrow-right me-1"></i>
                  Ouvrir le master
                </router-link>
                <button v-if="canPromoteToMaster && hasRole('ROLE_ADMIN')" class="btn btn-light-primary" @click="unmergeContract">
                  <i class="fad fa-unlink me-1"></i>
                  Sortir du merge
                </button>
                <button v-if="canPromoteToMaster && hasRole('ROLE_ADMIN')" class="btn btn-primary" @click="promoteToMaster">
                  <i class="fad fa-crown me-1"></i>
                  Faire de ce contrat le master
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-wrap gap-5 flex-sm-nowrap">
                <div>
                  <div class="symbol symbol-100px symbol-fixed position-relative p-5 shadow-xs ">
                    <img v-if="contract.insurer && contract.insurer.photo" :src="uploadRoot + contract.insurer.photo" alt="image" class="object-contain rounded"/>
                    <div v-else class="w-100px h-100px h-lg-175px w-lg-160px d-flex align-items-center justify-content-center shadow-xs rounded">
                      <i class="fad fa-cogs fs-5x"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="text-gray-800 text-hover-primary fs-2 fw-bolder">
                    {{ contract.insurer.label }}
                  </div>
                  <div class="fs-6 fw-bolder text-uppercase text-muted">
                    {{ contract.type }} {{ contract.branch.label }}
                  </div>
                  <!--                <div class=" fw-bolder">-->
                  <!--                  {{ contract.number }}-->
                  <!--                </div>-->
                  <div v-if="contract.police" class="fs-2 text-primary fw-bolder my-2">
                    {{ contract.police }}
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <div v-if="contract.startAt" class="badge badge-light-success">
                      {{ datify(contract.startAt, 'dMy H:i:s') }}
                    </div>
                    <i class="fad fa-arrows-left-right"></i>
                    <div v-if="contract.expireAt" class="badge badge-light-danger">
                      {{ datify(contract.expireAt, 'dMy H:i:s') }}
                    </div>
                  </div>

                </div>
              </div>
              <div>

              </div>
              <div class="d-flex flex-wrap gap-5 ">
                <div class="text-end">
                  <div class="text-gray-800 text-hover-primary fs-2 fw-bolder">
                    {{ contract.subscriber?.name }}&nbsp;
                  </div>
                  <div class="fs-6 fw-bolder text-uppercase text-muted">
                    {{ contract.subscriber?.prename }}&nbsp;
                  </div>
                  <!--                <div class=" fw-bolder">-->
                  <!--                  {{ contract.number }}-->
                  <!--                </div>-->
                  <div class="fs-2 text-primary fw-bolder my-2">
                    {{ phoneFormat(contract.subscriber.mobile) }}
                  </div>
                  <div>
                    Client depuis le {{ datify(contract.subscriber.createdAt, 'dMy') }}
                  </div>

                </div>
                <div>
                  <div class="symbol symbol-100px symbol-fixed position-relative p-5 shadow-xs  rounded">
                    <img v-if="contract.subscriber?.photo" :src="uploadRoot + contract.subscriber?.photo" alt="image" class="object-contain rounded"/>
                    <div v-else class="w-100px h-100px  d-flex align-items-center justify-content-center ">
                      <i class="fad fa-user fs-5x"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between py-5 my-5">
              <div>
                <ManagerSelector v-model="contract.manager"/>
              </div>
              <div>
                <div class="fw-bolder text-end mb-2 text-uppercase">
                  Apporteur
                </div>
                <PartnerSelector v-model="contract.partnerCode" @input="switchPartner"/>
              </div>
            </div>

            <div class="d-flex flex-wrap gap-5 justify-content-between align-items-center">
              <div class="d-flex flex-wrap gap-5">
                <div :class="['bg-'+contractColorPseudo(contract) ]" class="rounded min-w-125px py-3 px-4">
                  <div :class="['text-inverse-'+contractColorPseudo(contract) ]" class="fs-3 fw-bolder counted">
                    {{ contract.status }}
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <div class="text-gray-400 fs-3">
                      <i :class="['text-inverse-'+contractColorPseudo(contract) ]" class="fad fa-dot-circle"></i>
                    </div>
                    <div class="fw-bold fs-6 text-white">
                      Status
                    </div>
                  </div>
                </div>
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4">
                  <div class="fs-3 fw-bolder counted">
                    {{ currency(contract.primeTTC) }}
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <div class="text-gray-400 fs-3">
                      <i class="fad fa-coins"></i>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">
                      Prime TTC
                    </div>
                  </div>
                </div>
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4">
                  <div class="fs-3 fw-bolder counted">
                    {{ contract.duration }}
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <div class="text-gray-400 fs-3">
                      <i class="fad fa-stopwatch"></i>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">
                      Durée
                    </div>
                  </div>
                </div>
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4">
                  <div class="fs-3 fw-bolder counted text-danger">
                    {{ currency(contract.balance, true) }}
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <div class="text-gray-400 fs-3">
                      <i class="fad fa-money-bill-wave"></i>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">
                      Impayés
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div v-if="hasRole('ROLE_ADMIN') && canDelete()" class="btn btn-danger btn-sm" @click="removeContract">
                  <i class="fad fa-trash-alt"></i>
                  Supprimer
                </div>
                <div v-if="hasRole('ROLE_ADMIN') && contract.deletedAt" class="btn btn-success btn-sm" @click="restoreContract">
                  <i class="fad fa-rotate-left me-1"></i>
                  Restaurer
                </div>
                <div v-if="hasRole('ROLE_ADMIN') && !mergedTo" class="ms-5 btn btn-light-warning" v-b-modal.similar-contracts-modal>
                  <i class="fad fa-code-merge me-1"></i>
                  Contrats similaires
                </div>
                <div v-if="hasRole('ROLE_ADMIN') && !mergedTo" class="ms-5 btn btn-light-info" v-b-modal.recover-orphans-modal>
                  <i class="fad fa-heart-pulse me-1"></i>
                  Récupérer orphelins
                </div>
                <router-link :to="{name: 'renew-contract',params: { contractUuid: contract.uuid }}" class="ms-5 btn-sm btn btn-primary" target="_blank">
                  Renouveller
                </router-link>
              </div>
            </div>
            <b-tabs v-model="tabIndex" nav-wrapper-class="nav mt-5 nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap    flex-grow-1">
              <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadAvenants">
                <template #title>
                  <div class="d-flex align-items-center">
                    <i class="fad fa-layer-group fs-2 me-2"></i>
                    Avenants
                  </div>
                </template>
              </b-tab>
              <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'">
                <template #title>
                  <div class="d-flex align-items-center">
                    <i class="fad fa-object-group fs-2 me-2"></i>
                    Actifs
                  </div>
                </template>
              </b-tab>
              <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadInvoices">
                <template #title>
                  <div class="d-flex align-items-center">
                    <i class="fad fa-file-contract fs-2 me-2"></i>
                    Factures
                  </div>
                </template>
              </b-tab>
              <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadPayments">
                <template #title>
                  <div class="d-flex align-items-center">
                    <i class="fad fa-coins fs-2 me-2"></i>
                    Paiements
                  </div>
                </template>
              </b-tab>
              <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadAccesses">
                <template #title>
                  <div class="d-flex align-items-center">
                    <i class="fad fa-file fs-2 me-2"></i>
                    Accès
                  </div>
                </template>
              </b-tab>
            </b-tabs>
          </div>
        </div>

        <!--        <div class="card">-->
        <!--          <div class="card-body">-->
        <AvenantHorizontalTimeline v-if="contract" :key="'timeline_'+contract.uuid" :contract="contract" v-model="currentDate" :avenants="avenants" :insurers="insurers"/>
        <!--          </div>-->
        <!--        </div>-->

        <div key="avenants" class="card min-h-800px">
          <div class="card-body">
            <Loading v-if="isLoading"></Loading>
            <template v-else-if="contract">
              <div v-if="tabIndex === 0" class="flex-1">
                <div class="py-5">
                  <div class="d-flex justify-content-end align-items-center gap-3">
                    <div v-if="hasRole('ROLE_ADMIN') && avenants && avenants.length === 0" class="btn btn-light-info btn-sm" v-b-modal.restore-avenants-modal>
                      <i class="fad fa-rotate-left me-1"></i>
                      Récupérer des avenants
                    </div>
                    <b-dropdown v-if="canAddAvenant()" class="" no-flip right size="sm" tag="div" variant="primary">
                      <template v-slot:button-content>
                        Effectuer un avenant
                      </template>
                      <!--                      <b-dropdown-item tag="div" @click="subscribeRenewalCampaign">-->
                      <!--                        <div class="px-5 py-2 cursor-pointer d-flex align-items-center">-->
                      <!--                          <i class="fad fa-sms fs-2 me-2"></i>-->
                      <!--                          Lancer la campagne de renouvellement-->
                      <!--                        </div>-->
                      <!--                      </b-dropdown-item>-->
                      <!--                      <b-dropdown-item tag="div">-->
                      <!--                        <router-link :to="{-->
                      <!--                  name: 'contract-renewal',-->
                      <!--                  params: { uuid: contract.uuid },-->
                      <!--                }" class="text-dark">-->
                      <!--                          <div class="px-5 py-2 cursor-pointer d-flex align-items-center">-->
                      <!--                            <i class="fad fa-sync fs-2 me-2"></i>-->
                      <!--                            Renouveller le contrat-->
                      <!--                          </div>-->
                      <!--                        </router-link>-->
                      <!--                      </b-dropdown-item>-->
                      <template v-for="avenantType in authorizedAvenants">
                        <b-dropdown-item :key="avenantType.id" tag="div">
                          <router-link :to="avenantCreateRoute(avenantType)" class="text-dark">
                            <div class="px-5 py-2 cursor-pointer d-flex align-items-center">
                              <i class="fad fa-edit fs-2 me-2"></i>
                              {{ avenantType.label }}
                            </div>
                          </router-link>
                        </b-dropdown-item>
                      </template>
                    </b-dropdown>
                  </div>
                </div>
                <div class="overflow-auto flex-1">
                  <table class="table table-striped gy-3 gs-3">
                    <thead>
                    <tr class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
                      <th>Assureur</th>
                      <th>Création</th>
                      <th>Emission</th>
                      <th>Période</th>
                      <th>Montant</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="avenant in avenants">
                      <tr :key="'avenant_list_' + avenant.uuid" :style="{'--bs-table-accent-bg': avenant.deletedAt ? 'rgba(220,53,69,.15)' : 'transparent', backgroundColor: avenant.deletedAt ? 'rgba(220,53,69,.15)' : 'transparent'}">
                        <td class="position-relative">
                          <div v-if="contract.currentAvenantUuid == avenant.uuid" class=" fs-2x position-absolute h-100 bg-primary" style="left:0;top:0;width:5px;">

                          </div>
                          <div>
                          <span class="text-primary fw-bolder">
                            AV{{ avenant.numero }}
                          </span>
                            <span class="px-1">▪</span>
                            <span class="fw-bolder text-uppercase">
                              <template v-if="avenant.type">
                                {{ avenant.type }}
                              </template>
                              <template v-if="avenant.avenantType">
                                {{ avenant.avenantType.label }}
                              </template>
                          </span>
                          </div>
                          <div v-if="avenant.insurer" class="fw-bolder text-primary">
                            {{ insurers[avenant.insurer]?.label }}
                          </div>
                          <div class="text-muted fw-bolder">
                            {{ avenant.police }}
                          </div>
                        </td>
                        <td>
                          <div class="">
                            <UserView v-model="avenant.createBy"/>
                            <div class="text-primary fw-bolder">
                              {{ readableDate(avenant.createdAt, "dmy Hi") }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <UserView v-model="avenant.emitBy"/>
                            <div class="text-primary fw-bolder">
                              {{ readableDate(avenant.dateEmission, "dmy Hi") }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fw-bolder d-flex align-items-center">
                            <div v-if="avenant.dateEffet" v-b-tooltip.hover :title="readableDate(avenant.dateEffet, 'dmY')">
                              {{ readableDate(avenant.dateEffet, "dmy") }}
                            </div>
                            <div class="mx-1 d-flex align-items-center">↔</div>
                            <div v-if="avenant.dateEcheance" v-b-tooltip.hover :title="readableDate(avenant.dateEcheance, 'dmY')">
                              {{ readableDate(avenant.dateEcheance, "dmy") }}
                            </div>
                          </div>
                          <div class="fw-bolder text-gray-400">
                            {{ avenant.duree }}
                          </div>
                          <div v-if="hasRole('ROLE_ADMIN')" class="text-muted fw-bolder fs-8">
                            {{ avenant.uuid }}
                          </div>
                        </td>
                        <td class="fw-bolder">
                          {{ currency(avenant.primeTTC) }}

                          <div class="text-danger">
                            {{ currency(avenant.balance, true) }}
                          </div>
                        </td>

                        <td>
                          <span
                              :class="{
                              'badge-warning':
                                avenant.status ===
                                CONSTANTS.AVENANT_STATUS.PROJET,
                              'badge-primary':
                                avenant.status ===
                                CONSTANTS.AVENANT_STATUS.VALIDE,
                              'badge-success':
                                avenant.status ===
                                CONSTANTS.AVENANT_STATUS.EN_COURS,
                              'badge-danger':
                                avenant.status ===
                                CONSTANTS.AVENANT_STATUS.EXPIRED,
                            }"
                              class="badge"
                          >
                            {{ avenant.status }}
                          </span>
                          <span v-if="isAvenantAntidated(avenant)"
                                class="badge badge-light-warning ms-1"
                                v-b-tooltip.hover
                                title="Date d'effet antérieure à aujourd'hui — ASACI non déclenché">
                            <i class="fad fa-clock-rotate-left me-1"></i>Antidaté
                          </span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex align-items-center justify-content-center gap-2">
                            <!-- AVENANT SUPPRIME : editer, emettre ou encaisser n'a aucun sens
                                 tant qu'il n'est pas releve. La seule action offerte est donc
                                 la restauration (+ la consultation). -->
                            <template v-if="avenant.deletedAt">
                              <!-- ROLE_ADMIN, comme la suppression : c'est la meme decision,
                                   dans l'autre sens. La carte des acces le refuse de toute
                                   facon aux autres, autant ne pas leur montrer le bouton. -->
                              <div v-if="hasRole('ROLE_ADMIN')"
                                   v-b-tooltip.hover
                                   :title="'Supprime le ' + readableDate(avenant.deletedAt, 'dmy Hi') + ' - restaurer cet avenant'"
                                   class="btn btn-success btn-xs btn-icon" @click="restoreAvenant(avenant)">
                                <i class="fad fa-trash-arrow-up"></i>
                              </div>
                              <router-link :to="{name: 'avenant-show',params: { uuid: avenant.uuid }}" class="btn btn-dark btn-xs btn-icon">
                                <i class="fad fa-eye"></i>
                              </router-link>
                            </template>
                            <template v-else>
                            <router-link v-if="canEditAvenant(avenant)" :to="{name: 'avenant-edit',params: {contractUuid: contract.uuid,avenantUuid: avenant.uuid,avenantType:  avenant.avenantType?.code}}">
                              <div class="btn btn-info btn-xs btn-icon">
                                <i class="fad fa-edit"></i>
                              </div>
                            </router-link>
                            <b-dropdown v-if="canEmitAvenant(avenant)" no-caret no-flip right size="sm" tag="div" toggle-class="topbar-item text-decoration-none p-0" variant="link" boundary="viewport">
                              <template v-slot:button-content>
                                <div class="btn btn-warning btn-xs btn-icon" v-b-tooltip.hover title="Emettre cet avenant">
                                  <i class="fad fa-check-double"></i>
                                </div>
                              </template>
                              <b-dropdown-text class="min-w-md-300px p-5" tag="div">
                                <h4>Emission AV{{ avenant.numero }}</h4>
                                <p class="text-muted small">Emettre cet avenant sans encaissement</p>
                                <div v-if="isAvenantAntidated(avenant)" class="alert alert-warning py-2 px-3 my-3 small">
                                  <i class="fad fa-exclamation-triangle me-1"></i>
                                  Avenant antidaté (effet au {{ new Date(avenant.dateEffet).toLocaleDateString('fr-FR') }}).
                                  Les attestations ASACI ne seront <b>pas</b> générées.
                                </div>
                                <div v-else-if="hasAsaciWorkflow && Number(avenant.hasAttestations) === 0" class="form-check form-switch d-flex align-items-center gap-3 my-3">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'emitAttestation_' + avenant.uuid"
                                    :checked="shouldGenerateAttestations(avenant.uuid)"
                                    @change="setAttestationFlag(avenant.uuid, $event.target.checked)"
                                  >
                                  <label class="form-check-label fw-bolder" :for="'emitAttestation_' + avenant.uuid">Générer les attestations</label>
                                </div>
                                <div class="btn btn-warning btn-sm w-100" @click="emitAvenant(avenant)">
                                  <i class="fad fa-check-double me-2"></i>Emettre l'avenant
                                </div>
                              </b-dropdown-text>
                            </b-dropdown>
                            <!--                              <div v-b-modal="'avenantViewer'" class="btn btn-primary btn-xs btn-icon" @click="setAvenant(avenant)">-->
                            <!--                                <i class="fad fa-file-signature"></i>-->
                            <!--                              </div>-->
                            <b-dropdown v-if="(avenant.balance !== 0 && hasRole('ROLE_MANAGER')) || avenant.balance < 0"
                                        no-caret no-flip right size="sm" tag="div" toggle-class="topbar-item text-decoration-none p-0" variant="link" boundary="viewport">
                              <template v-slot:button-content>
                                <div class="btn btn-success  btn-xs btn-icon" @click="amount = abs(avenant.invoicesBalance)">
                                  <i class="fad fa-money-bill-wave"></i>
                                </div>
                              </template>
                              <b-dropdown-text class="min-w-md-350px p-5" tag="div">
                                <h4>
                                  AV{{ avenant.numero }} ▪ {{ avenant.type }}
                                </h4>
                                <div>
                                  <label class="fw-bolder mb-2" for="">
                                    {{ trans("Recharger le compte client et payer") }}
                                  </label>
                                  <div>
                                    <b-input-group>
                                      <b-form-input v-model="amount" class="text-end" type="number"></b-form-input>
                                      <b-input-group-append>
                                        <div class="btn btn-sm border-radius-left-0 d-flex align-items-center btn-primary h-100" @click="payAvenant(avenant)">
                                          <i class="fad fa-money-bill"></i>
                                          Payer
                                        </div>
                                      </b-input-group-append>
                                    </b-input-group>
                                  </div>
                                  <div v-if="isAvenantAntidated(avenant)" class="alert alert-warning py-2 px-3 mt-3 small">
                                    <i class="fad fa-exclamation-triangle me-1"></i>
                                    Avenant antidaté — les attestations ASACI ne seront <b>pas</b> générées.
                                  </div>
                                  <div v-else-if="hasAsaciWorkflow && Number(avenant.hasAttestations) === 0" class="form-check form-switch d-flex align-items-center gap-3 mt-3">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'payAttestation_' + avenant.uuid"
                                      :checked="shouldGenerateAttestations(avenant.uuid)"
                                      @change="setAttestationFlag(avenant.uuid, $event.target.checked)"
                                    >
                                    <label class="form-check-label fw-bolder" :for="'payAttestation_' + avenant.uuid">Générer les attestations</label>
                                  </div>
                                  <div class="mt-5">
                                    Si le compte client est suffisant le
                                    rechargement ne sera pas effectué
                                  </div>

                                  <div class="fw-bolder my-2 text-center">
                                    Envoyez un lien de paiement au
                                  </div>
                                  <div
                                      class="d-flex justify-content-center align-items-center"
                                  >
                                    <input
                                        v-model="linkPhoneNumber"
                                        class="form-control text-center ms-1 w-150px text-end"
                                        placeholder="Numéro de téléphone"
                                        type="text"
                                    />
                                  </div>
                                  <div
                                      class="d-flex justify-content-center align-items-center"
                                  >
                                    <template
                                        v-for="(method, index) in paymentMethods"
                                    >
                                      <div
                                          v-if="!method.requireManagerValidation"
                                          :key="index"
                                          class="m-5 cursor-pointer d-flex align-items-center"
                                          @click="
                                          sendPaymentLink(method, avenant)
                                        "
                                      >
                                        <img
                                            :src="uploadRoot + method.photo"
                                            alt=""
                                            class="w-40px h-40px rounded"
                                        />
                                      </div>
                                    </template>
                                    <div
                                        class="m-5 cursor-pointer d-flex align-items-center justify-content-center bg-primary w-40px h-40px rounded"
                                        @click="sendPaymentLink(null, avenant)"
                                    >
                                      <i
                                          class="fad fa-list fs-2 text-inverse-primary"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </b-dropdown-text>
                            </b-dropdown>
                            <template v-if="avenant.status === CONSTANTS.AVENANT_STATUS.PROJET">
                              <b-dropdown no-caret no-flip right size="sm" tag="div" toggle-class="topbar-item text-decoration-none p-0" variant="link">
                                <template v-slot:button-content>
                                  <div class="btn btn-info  btn-xs btn-icon" @click="amount = abs(avenant.balance)">
                                    <i class="fad fa-forward"></i>
                                  </div>
                                </template>
                                <b-dropdown-text class="min-w-md-350px p-5" tag="div">
                                  <h4>Avancer la date d'effet</h4>
                                  <div>
                                    <label class="fw-bolder mb-2" for="">
                                      {{ trans("Nouvelle date d'effet") }}
                                    </label>
                                    <div class="d-flex align-items-center">
                                      <input v-model="dateEffet" class="form-control" type="date"/>
                                      <div class="btn btn-sm border-radius-left-0 btn-primary" @click="forwardAvenant(avenant)">
                                        Avancer
                                      </div>
                                    </div>
                                  </div>
                                </b-dropdown-text>
                              </b-dropdown>
                            </template>
                            <router-link :to="{name: 'avenant-show',params: { uuid: avenant.uuid }}" class="btn btn-dark btn-xs btn-icon">
                              <i class="fad fa-eye"></i>
                            </router-link>
                            <div v-if="hasRole('ROLE_MANAGER') || hasRole('ROLE_ADMIN')"
                                 v-b-tooltip.hover title="Régénérer coverages de cet avenant"
                                 class="btn btn-light-primary btn-xs btn-icon" @click="regenerateAvenantCoverages(avenant)">
                              <i class="fad fa-arrows-rotate"></i>
                            </div>
                            <div v-if="avenant.status === CONSTANTS.AVENANT_STATUS.PROJET || hasRole('ROLE_ADMIN')"
                                 class="btn btn-danger btn-xs btn-icon" @click="removeAvenantProject(avenant)">
                              <i class="fad fa-ban"></i>
                            </div>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="tabIndex === 1">
                <Loading v-if="isLoading"></Loading>
                <AssetList :avenants="avenants" :contract-uuid="contract.uuid" :currentDate="currentDate" :contractCreatedAt="contract.createdAt"/>

                <!--                <table class="table table-striped gx-5">-->
                <!--                  <thead>-->
                <!--                  <tr>-->
                <!--                    <th>Alias</th>-->
                <!--                    <th>Identifiant</th>-->
                <!--                    <th></th>-->
                <!--                    <th>Couverture</th>-->
                <!--                    <th>Prime HT</th>-->
                <!--                    <th>Documents</th>-->
                <!--                  </tr>-->
                <!--                  </thead>-->
                <!--                  <tbody>-->
                <!--                  <tr v-for="(item,key) in items">-->
                <!--                    <td>-->
                <!--                      {{ item.alias }}-->
                <!--                    </td>-->
                <!--                    <td>-->
                <!--                      {{ item.identifier }}-->
                <!--                    </td>-->
                <!--                    <td>-->

                <!--                    </td>-->
                <!--                    <td>-->
                <!--                      {{ item.coverage?.label }}-->
                <!--                    </td>-->
                <!--                    <td>-->
                <!--                      {{ currency(item.premium) }}-->
                <!--                    </td>-->
                <!--                    <td>-->
                <!--                      <div class="d-flex flex-wrap gap-2">-->

                <!--                        <b-dropdown no-caret size="sm" toggle-class="btn-icon" variant="primary">-->
                <!--                          <template v-slot:button-content>-->
                <!--                            <i class="fad fa-file"></i>-->
                <!--                          </template>-->
                <!--                          <b-dropdown-item v-for="(printable,slug) in itemTypes[item.modelCode].printables" :key="'printable_'+printable.id">-->
                <!--                            <div class="d-flex align-items-center justify-content-between gap-10">-->
                <!--                              <div class="py-2 d-flex gap-5 align-items-center">-->
                <!--                                <i v-if="printable.icon+' fs-2'" :class="printable.icon"></i>-->
                <!--                                <i v-else class="fad fa-file fs-2"></i>-->
                <!--                                {{ printable.label }}-->
                <!--                              </div>-->
                <!--                              <div class="d-flex align-items-center justify-content-center">-->
                <!--                                <i class="fad fa-external-link"></i>-->
                <!--                              </div>-->
                <!--                            </div>-->
                <!--                          </b-dropdown-item>-->
                <!--                        </b-dropdown>-->
                <!--                        &lt;!&ndash;                        <div v-for="(printable,slug) in itemTypes[item.modelCode].printables" :title="printable.label" class="btn btn-icon btn-light-primary btn-sm">&ndash;&gt;-->
                <!--                        &lt;!&ndash;                          <i v-if="printable.icon" :class="printable.icon"></i>&ndash;&gt;-->
                <!--                        &lt;!&ndash;                          <i v-else class="fad fa-file fs-2"></i>&ndash;&gt;-->
                <!--                        &lt;!&ndash;                        </div>&ndash;&gt;-->
                <!--                      </div>-->
                <!--                    </td>-->
                <!--                  </tr>-->
                <!--                  </tbody>-->
                <!--                </table>-->

              </div>
              <div v-if="tabIndex === 2">
                <div class="card mb-5">
                  <div
                      class="card-body border border-dashed border-gray-300 rounded min-w-700px"
                  >
                    <Loading v-if="isLoading"></Loading>
                    <h3>Factures</h3>

                    <div
                        v-if="pendingTransfer"
                        class="alert alert-info d-flex align-items-center justify-content-between mb-4"
                    >
                      <div>
                        <i class="fad fa-money-bill-transfer me-2"></i>
                        <strong>Transfert en attente :</strong>
                        {{ currency(pendingTransfer.amount) }}
                        <span class="text-muted ms-2">
                          - Cliquez sur une facture non payée pour affecter ce
                          paiement
                        </span>
                      </div>
                      <div
                          class="btn btn-sm btn-light-danger"
                          @click="cancelPendingTransfer"
                      >
                        <i class="fad fa-times me-1"></i>
                        Annuler
                      </div>
                    </div>

                    <table
                        class="table table-row-dashed table-row-gray-300 align-middle table-striped g-4"
                    >
                      <thead>
                      <tr class="text-uppercase">
                        <td>
                          <div
                              class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input class="form-check-input" type="checkbox"/>
                          </div>
                        </td>
                        <th>Numéro</th>
                        <th>Creér le</th>
                        <th>A payer le</th>
                        <th>Montant</th>
                        <th>Reste à payer</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="invoice in invoices">
                        <td>
                          <div
                              class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input class="form-check-input" type="checkbox"/>
                          </div>
                        </td>
                        <td>
                          {{ invoice.number }}
                        </td>
                        <td>
                          {{ datify(invoice.createdAt, "dmY") }}
                        </td>
                        <td>
                          {{ datify(invoice.dueDate, "dmY") }}
                        </td>
                        <td class="fw-bolder fs-2">
                          {{ currency(invoice.premium) }}
                        </td>
                        <td
                            :class="{
                              'text-danger': Math.abs(invoice.balance) > 0,
                            }"
                            class="fw-bolder fs-2"
                        >
                          {{ currency(invoice.balance, true) }}
                        </td>
                        <td>
                            <span
                                :class="{
                                'badge-secondary': invoice.status === 'PENDING',
                                'badge-light-success': invoice.status === 'PAYED',
                                'badge-light-danger':  invoice.status === 'CANCELLED',
                              }"
                                class="badge text-uppercase badge-secondary"
                            >
                              {{ invoice.status }}
                            </span>
                        </td>
                        <td>
                          <div class="d-flex gap-2">
                            <div
                                class="btn btn-icon btn-xs btn-primary"
                                @click="downloadInvoice(invoice)"
                            >
                              <i class="fad fa-file-pdf"></i>
                            </div>
                            <div
                                v-if="
                                  pendingTransfer && invoice.status === 'DUE'
                                "
                                v-b-tooltip.hover
                                class="btn btn-icon btn-xs btn-success"
                                title="Affecter le paiement en attente"
                                @click="applyTransferToInvoice(invoice)"
                            >
                              <i class="fad fa-money-bill-transfer"></i>
                            </div>
                            <div
                                v-if="
                                  hasRole('ROLE_ADMIN') &&
                                  invoice.status === 'DUE' &&
                                  contract.subscriber &&
                                  contract.subscriber.account &&
                                  contract.subscriber.account.balance > 0
                                "
                                v-b-tooltip.hover
                                :title="
                                  'Payer avec le solde client (' +
                                  currency(
                                    contract.subscriber.account.balance
                                  ) +
                                  ')'
                                "
                                class="btn btn-icon btn-xs btn-warning"
                                @click="payWithCustomerBalance(invoice)"
                            >
                              <i class="fad fa-wallet"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--                  <div class="d-flex align-items-center p-5">-->
                    <!--                    <div class="d-flex flex-aligns-center pe-10 pe-lg-20">-->

                    <!--                      <div class="d-flex align-items-center me-2">-->
                    <!--                        <i class="fad fa-file-pdf fs-3x text-primary"></i>-->
                    <!--                      </div>-->
                    <!--                      <div class="ms-1 fw-bold">-->
                    <!--                        <a class="fs-6 text-hover-primary fw-bolder" href="#">Devis</a>-->
                    <!--                        <br/>-->
                    <!--                        <span class="fs-6x fw-bolder text-gray-400">80 kb</span>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="d-flex flex-aligns-center">-->
                    <!--                      <div class="d-flex align-items-center me-2">-->
                    <!--                        <i class="fad fa-file-pdf fs-3x text-primary"></i>-->
                    <!--                      </div>-->
                    <!--                      <div class="ms-1 fw-bold">-->
                    <!--                        <a class="fs-6 text-hover-primary fw-bolder" href="#">Contrat</a>-->
                    <!--                        <br/>-->
                    <!--                        <span class="fs-6x fw-bolder text-gray-400">80 kb</span>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                  </div>-->

                    <div class="separator my-10"></div>
                  </div>
                </div>
              </div>
              <div v-if="tabIndex === 3">
                <Loading v-if="isLoading"></Loading>
                <div class="d-flex justify-content-end mb-10">
                  <b-dropdown
                      v-if="canDelete()"
                      no-caret
                      no-flip
                      right
                      size="sm"
                      tag="div"
                      toggle-class="topbar-item text-decoration-none p-0"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <div class="btn btn-success btn-sm">
                        Remplacer des paiements en espèce
                      </div>
                    </template>
                    <b-dropdown-text
                        class="min-w-md-150px p-5 text-center"
                        tag="div"
                    >
                      <div v-if="empty(transactionIds)" class="text-center">
                        <i class="fad fa-empty-set fs-5x"></i>
                        <div class="mt-5 fw-bolder">
                          Sélectionnez des paiements à remplacer
                        </div>
                      </div>
                      <div v-else>
                        <div class="fw-bolder">
                          Remplacer {{ transactionIds.length }} Paiements
                        </div>
                        <div class="d-flex justify-content-center">
                          <div
                              class="fs-2 fw-bolder badge badge-light-primary mt-5"
                          >
                            {{ currency(getReplacedAmount()) }}
                          </div>
                        </div>
                        <label class="fw-bolder my-5" for="">
                          {{ trans("Sélectionnez une methode") }}
                        </label>
                        <div class="d-flex">
                          <template v-for="(method, index) in paymentMethods">
                            <div
                                v-if="!method.requireManagerValidation"
                                :key="index"
                                :class="{
                                'badge-light-primary':
                                  selectedMethod &&
                                  method.id === selectedMethod.id,
                              }"
                                class="m-1 cursor-pointer badge"
                                @click="setReplacementMethod(method)"
                            >
                              <div>
                                <img
                                    :src="uploadRoot + method.photo"
                                    alt=""
                                    class="w-50px h-50px rounded"
                                />
                              </div>
                              <div class="text-center">
                                {{ method.label }}
                              </div>
                            </div>
                          </template>
                        </div>

                        <div
                            v-if="
                            selectedMethod && selectedMethod.requirePhoneNumber
                          "
                        >
                          Entrez le numéro de téléphone :
                          <input
                              v-model="replacementNumber"
                              class="form-control"
                              type="text"
                          />
                        </div>

                        <div class="d-flex mt-5 justify-content-center">
                          <div
                              :class="{
                              'btn-primary': selectedMethod,
                              'btn-secondary': selectedMethod === null,
                            }"
                              class="btn"
                              @click="replaceTransactions"
                          >
                            Remplacer
                          </div>
                        </div>
                      </div>
                    </b-dropdown-text>
                  </b-dropdown>
                </div>
                <table class="table table-stripped gy-3 gs-3">
                  <thead>
                  <tr
                      class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200"
                  >
                    <th>
                      <label class="checkbox checkbox-lg checkbox-inline">
                        <input type="checkbox"/>
                        <span></span>
                      </label>
                    </th>
                    <th>#</th>
                    <th>Methode</th>
                    <td>Opération</td>
                    <th>Initiateur</th>
                    <th>Montant</th>
                    <th>Status</th>
                    <th>Reçu</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="transaction in transactions">
                    <td>
                      <label class="checkbox checkbox-lg checkbox-inline">
                        <input
                            :checked="transactionIds.includes(transaction.id)"
                            type="checkbox"
                            @change="toggleTransaction(transaction)"
                        />
                        <span></span>
                      </label>
                    </td>
                    <td>
                      <div class="fw-bolder">
                        {{ currency(transaction.id, false, false) }}
                      </div>
                    </td>
                    <td>
                      <div>
                        <img
                            :src="uploadRoot + transaction.method.photo"
                            alt=""
                            class="w-30px h-30px rounded"
                        />
                        <span class="fw-bolder">
                            {{ transaction.method.label }}
                          </span>
                      </div>

                      <div class="fs-6 text-gray-400 fw-bolder">
                        {{ readableDate(transaction.createdAt) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                          <span
                              v-if="transaction.credit"
                              class="ms-3 fw-bolder badge badge-light-danger"
                          >
                            {{ transaction.credit.description }}
                          </span>
                        <div>
                          <i class="fad fa-arrow-right fs-2 mx-5"></i>
                        </div>
                        <div class="ms-3">
                          <div
                              v-if="transaction.debit"
                              class="fw-bolder badge badge-light-success"
                          >
                            {{ transaction.debit.description }}
                          </div>
                          <div>
                            <div
                                v-for="payment in transaction.replaced"
                                class="badge badge-secondary m-1 cursor-pointer"
                            >
                              N° {{ currency(payment.id, false, false) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                        <span class="fw-bolder">
                          <user-view v-model="transaction.initiator"/>
                        </span>
                    </td>
                    <td>
                        <span class="fw-bolder">
                          {{ currency(transaction.amount) }}
                        </span>
                    </td>
                    <td>
                        <span
                            :class="{
                            'badge-success': transaction.status === 'SUCCEED',
                            'badge-secondary': transaction.status === 'PENDING',
                            'badge-danger': transaction.status === 'CANCELLED' || transaction.status === 'EXPIRED',
                          }"
                            class="badge"
                        >
                          {{ transaction.status }}
                        </span>
                    </td>
                    <td>
                      <div
                          v-if="
                            hasRole('ROLE_ADMIN') &&
                            transaction.method &&
                            transaction.method.slug === 'wave' &&
                            transaction.status === 'PENDING'
                          "
                          class="btn btn-icon btn-danger"
                          @click="simulateWave(transaction)"
                      >
                        <i class="fad fa-money-bill-1-wave"></i>
                      </div>
                      <div
                          v-if="
                            hasRole('ROLE_ADMIN') &&
                            transaction.method &&
                            transaction.status === 'PENDING' &&
                            (transaction.method.slug === 'momo' ||
                              (transaction.method &&
                                transaction.method.slug === 'flooz'))
                          "
                          class="btn btn-icon btn-danger"
                          @click="simulateHub2(transaction)"
                      >
                        <i class="fad fa-money-bill-1-wave"></i>
                      </div>
                      <router-link
                          v-if="transaction.receipt"
                          :to="{
                            name: 'receipt-show',
                            params: { uuid: transaction.receipt.uuid },
                          }"
                          class="btn btn-sm btn-icon btn-primary"
                          target="_blank"
                      >
                        <i class="fad fa-download"></i>
                      </router-link>
                    </td>
                    <td class="text-end">
                      <div v-if="transaction.status === 'SUCCEED'"
                           v-b-tooltip.hover
                           class="btn btn-info me-2 btn-xs btn-icon"
                           title="Transférer ce paiement"
                           @click="openTransferModal(transaction)"
                      >
                        <i class="fad fa-money-bill-transfer"></i>
                      </div>
                    </td>
                  </tr>
                  <tr class="border-top">
                    <td colspan="5"></td>
                    <td>
                      <div class="fw-bolder">
                        {{ currency(transactionPayedAmount) }}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="tabIndex === 4">
                <div>
                  <div class="d-flex align-items-center mb-3">
                    <h4 class="mb-0">Accès actifs</h4>
                    <span class="badge badge-secondary ms-2">{{ accesses.length }}</span>
                  </div>
                  <table class="table table-striped" v-if="accesses.length > 0">
                    <thead>
                      <tr>
                        <th>Identifiant</th>
                        <th>Objet</th>
                        <th>Source</th>
                        <th>Début</th>
                        <th>Fin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="access in accesses" :key="access.id || access.uuid">
                        <td>{{ access.identifier }}</td>
                        <td>{{ access.item ? (access.item.identifier || access.item.alias || access.item.generatedAlias || access.item.uuid) : '—' }}</td>
                        <td>
                          <span class="badge" :class="{
                            'badge-light-primary': access.source === 'beneficiary',
                            'badge-light-info': access.source === 'manager',
                            'badge-light-warning': access.source === 'manual',
                          }">{{ access.source || 'beneficiary' }}</span>
                        </td>
                        <td>{{ access.startAt ? new Date(access.startAt).toLocaleDateString() : '-' }}</td>
                        <td>{{ access.endAt ? new Date(access.endAt).toLocaleDateString() : '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="text-muted py-5 text-center">
                    Aucun accès actif
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <b-modal
            id="avenantViewer"
            :ref="'avenantViewer'"
            :title="trans('Avenant')"
            centered
            class="modal-fullscreen"
            scrollable
            size="xl"
        >
          <div v-if="avenant">
            <div class="d-flex align-items-center">
              <h2 class="flex-grow-1">
                AV{{ avenant.numero }} ▪ {{ avenant.type }}
              </h2>
              <span
                  :class="{
                  'badge-warning':
                    avenant.status === CONSTANTS.AVENANT_STATUS.PROJET,
                  'badge-success':
                    avenant.status === CONSTANTS.AVENANT_STATUS.VALIDE,
                }"
                  class="badge fs-2"
              >
                {{ avenant.status }}
              </span>
            </div>
            <div class="mt-5">
              <div class="fw-bolder d-flex align-items-center">
                <div
                    v-if="avenant.dateEffet"
                    v-b-tooltip.hover
                    :title="readableDate(avenant.dateEffet, 'dmY')"
                >
                  {{ readableDate(avenant.dateEffet, "dmy") }}
                </div>
                <div class="mx-1 d-flex align-items-center">↔</div>
                <div
                    v-if="avenant.dateEcheance"
                    v-b-tooltip.hover
                    :title="readableDate(avenant.dateEcheance, 'dmY')"
                >
                  {{ readableDate(avenant.dateEcheance, "dmy") }}
                </div>
              </div>
            </div>

            <div
                class="d-flex fw-bolder mt-5 align-items-center fs-6 flex-wrap justify-content-start"
            >
              <div v-for="pd in avenant.premiumDetails" class="me-5 mb-5">
                {{ pd.model.label }} :
                <span class="badge badge-primary fs-6">{{
                    currency(pd.premium)
                  }}</span>
              </div>
            </div>
            <div class="d-flex fw-bolder align-items-center fs-6 mb-5">
              <div class="">
                Prime TTC :
                <span class="badge badge-secondary fs-6">{{
                    currency(avenant.primeTTC)
                  }}</span>
              </div>
              <div class="border-start ms-4 ps-4">
                Reste à Payer :
                <span class="badge badge-danger fs-6">
                  {{ currency(avenant.balance, true) }}</span
                >
              </div>
            </div>
            <!--                    <div class="border-top border-bottom pt-5">-->
            <!--                        <h4>Details</h4>-->
            <!--                    </div>-->
            <Loading v-if="isLoadingAvenant"></Loading>
            <table v-else class="table table-striped">
              <thead>
              <tr
                  class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200"
              >
                <th>Actif</th>
                <th>Pack</th>
                <!--                            <th>Garanties</th>-->
                <th>Bénéficiaire</th>
                <th class="text-end">Prime</th>
                <th class="text-end">Actions</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item, index) in itemList">
                <tr
                    v-if="
                      item.model.className !== 'Customer' &&
                      !item.model.isRoot &&
                      (!item.parentItem ||
                        (item.parentItem && item.parentItem.expand))
                    "
                    :key="index"
                    style="height: 1px"
                >
                  <td class="p-0">
                    <label
                        :class="{ 'fw-bolder': itemHasChildren(item) }"
                        class="cursor-pointer w-100 h-100 d-flex align-items-center"
                    >
                      <input
                          v-model="item.expand"
                          class="hidden"
                          type="checkbox"
                          @change="toggleItemExpand(item, $event)"
                      />
                      <template v-for="index in item.level">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                      </template>
                      <template v-if="itemHasChildren(item)">
                        <i
                            v-if="!item.expand"
                            class="fad fa-angle-right me-2"
                        ></i>
                        <i v-else class="fad fa-angle-down me-2"></i>
                      </template>
                      <template
                          v-if="avenant.ins.includes(item.uuid)"
                          class=""
                      >
                        Incorporation
                      </template>
                      <!--                                        <template v-if="item.model.name !== item.name">-->
                      {{ item.model.name }}
                      <!--                                        </template>-->
                      <!--                                        {{item.name}}-->
                      <template v-if="!helper.empty(item.defaultAlias)">
                        {{ item.defaultAlias }}
                      </template>

                      <span
                          v-if="avenant.ins.includes(item.uuid)"
                          class="bg-light-success ms-4"
                      >
                          <i class="fad fa-plus-circle text-success"></i>
                        </span>
                    </label>
                  </td>
                  <td>
                    {{ getItemPack(item) ?? "Non defini" }}
                  </td>
                  <!--                                <td>-->
                  <!--                                    &lt;!&ndash;                                    <div class="d-flex flex-wrap">&ndash;&gt;-->
                  <!--                                    &lt;!&ndash;                                        <div class="btn btn-xs btn-icon m-1 btn-success" v-for="guarantee in item.guarantees" :title="guarantee.label" v-b-tooltip.hover>&ndash;&gt;-->
                  <!--                                    &lt;!&ndash;                                            <img :src="uploadRoot+guarantee.icon" alt="" class="mw-15px mh-15px">&ndash;&gt;-->
                  <!--                                    &lt;!&ndash;&lt;!&ndash;                                            {{guarantee.label}}&ndash;&gt;&ndash;&gt;-->
                  <!--                                    &lt;!&ndash;                                        </div>&ndash;&gt;-->
                  <!--                                    &lt;!&ndash;                                    </div>&ndash;&gt;-->
                  <!--                                </td>-->
                  <td>
                    &nbsp;
                    <span class="fw-bolder text-uppercase">
                        {{ item.beneficiaryIdentifier }}
                      </span>
                  </td>
                  <td class="text-end fw-bolder whitespace-no-wrap">
                    <template v-if="!helper.empty(item.premium)">
                      {{ currency(item.premium) }}
                    </template>
                    <span v-else class="badge badge-secondary">{{
                        currency(item.calculatedPremium)
                      }}</span>
                  </td>
                  <td class="text-end">
                    <div class="d-flex justify-content-end">
                      <div class="btn btn-xs btn-icon btn-primary me-2">
                        <i class="fad fa-edit"></i>
                      </div>

                      <div class="btn btn-xs btn-icon btn-danger me-2">
                        <i class="fad fa-trash"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>

            <div class="d-flex align-items-center p-5">
              <div class="d-flex flex-aligns-center pe-10 pe-lg-20">
                <div class="d-flex align-items-center me-2">
                  <i class="fad fa-file-pdf fs-3x text-primary"></i>
                </div>
                <div class="ms-1 fw-bold">
                  <a
                      :href="
                      coreEndpoint +
                      'avenant/devis/' +
                      avenant.uuid +
                      '?zone=' +
                      $store.state.mainStore.currentTenant.code
                    "
                      class="fs-6 text-hover-primary fw-bolder"
                      href="#"
                      target="_blank"
                  >Devis</a
                  >
                  <br/>
                  <a
                      :href="
                      coreEndpoint +
                      'avenant/devis/' +
                      avenant.uuid +
                      '?zone=' +
                      $store.state.mainStore.currentTenant.code
                    "
                      class="btn btn-primary btn-sm"
                      target="_blank"
                  >Visualiser</a
                  >
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal
            id="transferModal"
            ref="transferModal"
            cancel-title="Annuler"
            centered
            ok-title="Confirmer"
            ok-variant="primary"
            title="Confirmer le transfert"
            @ok="confirmTransfer"
        >
          <div v-if="transactionToTransfer" class="text-center">
            <i class="fad fa-money-bill-transfer fs-3x text-info mb-4"></i>
            <p>Voulez-vous transférer ce paiement vers une autre facture ?</p>
            <div class="alert alert-light-info border-info">
              <div class="fw-bolder fs-4">
                {{ currency(transactionToTransfer.amount) }}
              </div>
              <div class="text-muted">
                Transaction N° {{ transactionToTransfer.id }}
              </div>
            </div>
            <p class="text-muted small">
              Après confirmation, sélectionnez la facture de destination dans la
              liste des factures.
            </p>
          </div>
        </b-modal>

        <transition name="slide-left-back">
          <div v-if="item" class="bg-white position-fixed top-0 w-100 h-100 d-flex justify-content-end" style="right: 0; z-index: 101">
            <div class="filter position-fixed top-0 left-0 w-100 h-100" @click="hideAsset"></div>
            <div class="d-flex flex-column h-100 p-5 w-800px shadow-lg position-relative z-index-1 overflow-auto">
              <div class="d-flex justify-content-between align-items-center mb-5">
                <div class="fs-2 fw-bolder text-uppercase d-flex align-items-center gap-5">
                  <i :class="item.model.icon + ' fs-2x'"></i>
                  {{ item.identifier }}
                </div>
                <div>
                  <div class="btn btn-danger btn-icon btn-sm" @click="hideAsset">
                    <i class="fad fa-times"></i>
                  </div>
                </div>
              </div>

              <div class="row">
                <template v-for="property in item.properties">
                  <div v-if="!property.model.type.code.includes('OBJECT') && property.visible" :key="'property_' + property.uuid" class="col-4">
                    <div class="d-flex justify-content-between">
                      <label class="fw-bolder">
                        {{ property.name }}
                      </label>
                    </div>
                    <div class="form-control my-3 text-uppercase text-end">
                      {{ formattedValue(property) ?? "-" }}
                    </div>
                  </div>
                </template>
              </div>

              <div>
                <div class="fs-2 fw-bolder my-3 text-uppercase">
                  Couvertures
                </div>
                <div>
                  <div v-for="coverage in item.coverages" class="border-dashed rounded my-2">
                    <div class="d-flex justify-content-between cursor-pointer bg-hover-light-primary p-3"
                         @click="coverage.expand = !coverage.expand">
                      <div class="d-flex align-items-center">
                        <div>
                          <div>
                            <i
                                v-if="coverage.expand"
                                class="fad fa-angle-down me-5"
                            ></i>
                            <i v-else class="fad fa-angle-right me-5"></i>
                            <span class="fs-2 fw-bolder">
                              <img
                                  v-if="coverage.insurer.photo"
                                  :src="uploadRoot + coverage.insurer.photo"
                                  alt=""
                                  class="w-25px h-25px object-contain"
                              />
                              {{ coverage.insurer.label }} 🔸
                              {{ coverage.label }}
                            </span>
                          </div>
                          <div>
                            {{ datify(coverage.createdAt, "dMy") }}
                          </div>
                        </div>
                        <span class="badge badge-light-info ms-5">
                          {{ currency(coverage.premium) }}
                        </span>
                        <div class="ms-3">
                          <span
                              :class="{
                              'badge-light-success':
                                coverage.status === 'ACTIVE',
                              'badge-light-warning':
                                coverage.status === 'PENDING',
                              'badge-light-danger':
                                coverage.status === 'EXPIRED',
                            }"
                              class="badge"
                          >
                            {{ coverage.status }}
                          </span>
                        </div>
                      </div>
                      <div class="gap-2 d-flex align-items-center">
                        <div class="badge badge-success">
                          {{ readable(coverage.startAt, "dMy") }}
                        </div>
                        <div>
                          <i class="fad fa-arrows-left-right"></i>
                        </div>
                        <div v-if="coverage.endAt" class="badge badge-danger">
                          {{ readable(coverage.endAt, "dMy") }}
                        </div>
                      </div>
                    </div>

                    <div v-if="coverage.expand" class="m-5">
                      <div class="m-5">
                        <div class="fw-bolder fs-2">Garanties</div>
                        <div v-for="risk in coverage.risks" class="py-1 px-2">
                          <i class="fad fa-shield-alt me-3"></i>
                          {{ risk.label }}
                          <i
                              v-if="risk.isOptional"
                              class="fad fa-star text-warning"
                              title="Garantie Optionelle"
                          ></i>
                        </div>
                      </div>
                      <div class="m-5">
                        <div class="fw-bolder fs-2">Documents</div>
                        <div v-if="!(coverage.printables && coverage.printables.length > 0)" class="py-2 px-2">
                          <div class="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-2">
                            <div class="small">
                              <i class="fad fa-exclamation-triangle me-2"></i>
                              Aucun document n'a ete genere pour cette couverture
                            </div>
                            <button class="btn btn-sm btn-warning" :disabled="coverage.regenerating" @click="regenerateCoveragePrintables(coverage)">
                              <i v-if="!coverage.regenerating" class="fad fa-sync me-2"></i>
                              <i v-else class="fad fa-spinner fa-spin me-2"></i>
                              Générer les documents
                            </button>
                          </div>
                        </div>
                        <div v-for="printable in item.model.printables" class="py-1 px-2 d-flex justify-content-between align-items-center bg-hover-light-primary">
                          <div>
                            <i class="fad fa-file me-3"></i>
                            {{ printable.label }}
                          </div>
                          <div class="d-flex gap-2">
                            <template v-if="coverage.status === 'ACTIVE' || coverage.status === 'EXPIRED'">
                              <router-link :to="{name: 'coverage-printable-view',params: {printableUuid: printable.uuid,coverageUuid: coverage.uuid}}" class="d-flex justify-content-end ms-5" target="_blank">
                                <div class="btn btn-xs btn-primary btn-icon mx-1">
                                  <i class="fad fa-eye"></i>
                                </div>
                              </router-link>
                            </template>
                            <template v-else>
                              <span class="badge badge-light-danger">
                                Cette couverture est inactive
                              </span>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <SimilarContractsModal v-if="contract && contract.uuid" :contract-uuid="contract.uuid" @merged="onSimilarMerged"/>
        <RecoverOrphansModal v-if="contract && contract.uuid" :contract-uuid="contract.uuid" @recovered="onOrphansRecovered"/>
        <RestoreAvenantsModal v-if="contract && contract.uuid" :contract-uuid="contract.uuid" @restored="onAvenantsRestored"/>
      </div>
    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import Contract from "@/entity/Contract";
import {api} from "@/services/Api";
import Loading from "@/components/Loading.vue";
import FileUpload from "@/components/FileUpload.vue";
import Avenant from "@/entity/Avenant";
import CONSTANTS from "@/Utils/constant";
import Item from "@/entity/Item";
import UserView from "@/components/UserView.vue";
import VueMultiselect from "vue-multiselect/src/Multiselect.vue";
import Property from "@/entity/Property";
import IncorporationDetail from "@/views/Contract/IncorporationDetail.vue";
import Printable from "@/entity/Printable";
import { hydrateCollection } from "@/Utils/EntityHelper";
import Swal from "sweetalert2";
import User from "@/entity/User";
import Partner from "@/entity/Partner";
import PaymentMethod from "@/entity/PaymentMethod";
import Popup from "@/entity/Popup";
import {helper} from "@/services/Helper";
import AccountOperation from "@/entity/AccountOperation";
import PartnerView from "@/components/PartnerView.vue";
import TypeAvenant from "@/entity/TypeAvenant";
import PaymentTransaction from "@/entity/PaymentTransaction";
import Invoice from "@/entity/Invoice";
import AvenantType from "@/entity/AvenantType";
import FileList from "@/components/FileList.vue";
import SimilarContractsModal from "@/components/SimilarContractsModal.vue";
import RecoverOrphansModal from "@/components/RecoverOrphansModal.vue";
import RestoreAvenantsModal from "@/components/RestoreAvenantsModal.vue";
import {checkPropertyVisibility, formattedValue,} from "@/services/ItemFunction";
import AssetViewer from "@/components/AssetViewer.vue";
import ObjectNavigator from "@/components/ObjectNavigator/ObjectNavigator.vue";
import AssetList from "@/components/ObjectNavigator/AssetList.vue";
import {auth} from "@/services/Auth";
import PartnerSelector from "@/components/PartnerSelector.vue";
import ManagerSelector from "@/components/ManagerSelector.vue";
import AvenantHorizontalTimeline from "@/components/AvenantHorizontalTimeline.vue";

@Component({
  methods: {checkPropertyVisibility, formattedValue},
  components: {
    AvenantHorizontalTimeline,
    HorizontalTimeline: AvenantHorizontalTimeline,
    ManagerSelector,
    PartnerSelector,
    AssetList,
    ObjectNavigator,
    AssetViewer,
    PartnerView,
    IncorporationDetail,
    FileUpload,
    Loading,
    Base,
    UserView,
    VueMultiselect,
    FileList,
    SimilarContractsModal,
    RecoverOrphansModal,
    RestoreAvenantsModal,
  },
})
export default class ContractShow extends Vue {
  contract: Contract | any = null;
  contractNotFound = false;
  amount = 0;
  coreEndpoint = api.core;
  uploadRoot = api.uploadRoot;
  tabIndex = 1;
  isLoading = false;
  mergedTo: string | null = null;
  canPromoteToMaster = false;
  avenant: any = null;
  managers: User[] = [];
  partners: Partner[] = [];
  partnerUsers: Partner[] = [];
  userType: any = "manager";
  paymentMethods: PaymentMethod[] = [];
  dateEffet: any = null;
  paymentMethod = null;
  linkPhoneNumber = "";
  partnerSearched = "";
  items: any[] = [];
  authorizedAvenants: AvenantType[] = [];
  transactionIds: any[] = [];
  selectedMethod: any = null;
  replacementNumber = "";
  methodSelected = null;
  operations: AccountOperation[] = [];
  transactions: PaymentTransaction[] = [];
  invoices: Invoice[] = [];
  itemList: Item[] = [];
  isLoadingAvenant = false;
  avenantLink: any = null;
  typesAvenant: TypeAvenant[] = [];
  item: any = null as any;
  transactionToTransfer: PaymentTransaction | null = null;
  old = false
  printables = {}
  data = []
  avenantFilter = {
    page: 1,
    perPage: 50
  }
  avenants = []
  attestationFlags: Record<string, boolean> = {}

  currentDate = null
  insurers = {}
  accesses: any[] = []
  accessFilter = {
    page: 1,
    perPage: 50
  }

  get transactionPayedAmount() {
    let total = 0;
    this.transactions.forEach((t: PaymentTransaction) => {
      if (t.status === "SUCCEED" && t.replaced.length === 0) {
        total += t.amount;
      }
    });
    return total;
  }

  get itemTypes() {
    return this.$store.state.contractStore.itemTypes;
  }

  get hasAsaciWorkflow(): boolean {
    if (!this.itemTypes) return false;
    return Object.values(this.itemTypes).some((it: any) =>
      it.workflows && Array.isArray(it.workflows) && it.workflows.some((w: any) => w.code === 'asaci')
    );
  }

  get willExpireSoon() {
    if (this.contract instanceof Contract) {
      const now = new Date();
      const diff = this.contract.expireAt.getTime() - now.getTime();
      let dayLeft = Math.ceil(diff / (1000 * 3600 * 24));
      if (dayLeft < 30) {
        return true;
      }
      return false;
    }
    return false;
  }

  get pendingTransfer() {
    return this.$store.state.mainStore.pendingTransfer;
  }

  async regenerateAvenantCoverages(avenant: any) {
    const confirm = await Swal.fire({
      title: "Régénérer les coverages de cet avenant ?",
      html: `<div class='text-start'>
        Cet avenant est sous l'ancien format : ses items ont des <code>item_guarantees</code> mais pas encore de <b>coverages</b>/<b>risks</b>/<b>printables</b> consolidés.<br/><br/>
        L'action va :
        <ul>
          <li>Parcourir les items ajoutés par cet avenant</li>
          <li>Générer ou mettre à jour leurs <b>coverages</b> et <b>risks</b></li>
          <li>Consolider les <b>property values</b> historisées sur cet avenant</li>
        </ul>
        Pas de fusion avec d'autres contrats, scope limité à cet avenant.
      </div>`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Régénérer",
      cancelButtonText: "Annuler",
    });
    if (!confirm.isConfirmed) return;
    this.$store.commit("loading");
    let res: any = null;
    let err: any = null;
    try {
      res = await api.post(api.core, "avenant/convert/" + avenant.uuid, {});
    } catch (e: any) {
      err = e;
    }
    this.$store.commit("stopLoading");
    if (err) {
      await Swal.fire({icon: "error", title: "Échec", text: err?.response?.data?.message || err?.message || "Erreur"});
      return;
    }
    if (res?.data?.status === "success") {
      await Swal.fire({icon: "success", title: "Fait", html: `${res.data.items_processed ?? 0} item(s) traité(s).`});
      window.location.reload();
    } else {
      await Swal.fire({icon: "error", title: "Échec", text: res?.data?.message || "Erreur"});
    }
  }

  async restoreContract() {
    const confirm = await Swal.fire({
      title: "Restaurer ce contrat ?",
      html: "Le contrat et son arborescence (avenants, items) seront restaurés.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Restaurer",
      cancelButtonText: "Annuler",
    });
    if (!confirm.isConfirmed) return;
    this.$store.commit("loading");
    let res: any = null;
    let err: any = null;
    try {
      res = await api.post(api.core, "contract/restore/" + this.$route.params.contractUuid, {});
    } catch (e: any) {
      err = e;
    }
    this.$store.commit("stopLoading");
    if (err) {
      await Swal.fire({icon: "error", title: "Échec", text: err?.response?.data?.message || err?.message || "Erreur"});
      return;
    }
    if (res?.data?.status === "success") {
      await Swal.fire({icon: "success", title: "Contrat restauré"});
      window.location.reload();
    } else {
      await Swal.fire({icon: "error", title: "Échec", text: res?.data?.message || "Erreur"});
    }
  }

  async unmergeContract() {
    const confirm = await Swal.fire({
      title: "Sortir ce contrat du merge ?",
      html: "Ce contrat récupérera ses avenants et ne sera plus lié. Le contrat cible actuel reste inchangé.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirmer",
      cancelButtonText: "Annuler",
    });
    if (!confirm.isConfirmed) return;
    this.$store.commit("loading");
    let res: any = null;
    let err: any = null;
    try {
      res = await api.post(api.core, "contract/unmerge/" + this.$route.params.contractUuid, {});
    } catch (e: any) {
      err = e;
    }
    this.$store.commit("stopLoading");
    if (err) {
      await Swal.fire({icon: "error", title: "Échec", text: err?.response?.data?.message || err?.message || "Erreur"});
      return;
    }
    if (res?.data?.status === "success") {
      await Swal.fire({
        icon: "success",
        title: "Fait",
        html: `${res.data.avenants_restored ?? 0} avenant(s) rapatrié(s).`,
      });
      window.location.reload();
    } else {
      await Swal.fire({icon: "error", title: "Échec", text: res?.data?.message || "Erreur"});
    }
  }

  async promoteToMaster() {
    const confirm = await Swal.fire({
      title: "Inverser le merge ?",
      html: "Ce contrat deviendra master. Ses avenants seront rapatriés et le contrat cible actuel sera marqué comme duplicate.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirmer",
      cancelButtonText: "Annuler",
    });
    if (!confirm.isConfirmed) return;
    this.$store.commit("loading");
    let res: any = null;
    let err: any = null;
    try {
      res = await api.post(api.core, "contract/promote/" + this.$route.params.contractUuid, {});
    } catch (e: any) {
      err = e;
    }
    this.$store.commit("stopLoading");
    if (err) {
      await Swal.fire({icon: "error", title: "Échec", text: err?.response?.data?.message || err?.message || "Erreur"});
      return;
    }
    if (res?.data?.status === "success") {
      await Swal.fire({
        icon: "success",
        title: "Fait",
        html: `${res.data.avenants_restored ?? 0} avenant(s) rapatrié(s).`,
      });
      window.location.reload();
    } else {
      await Swal.fire({icon: "error", title: "Échec", text: res?.data?.message || "Erreur"});
    }
  }

  async removeContract() {
    const response = await Swal.fire({
      title: "Attention",
      html: "Supprimer ce contrat ?",
      timer: 30000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
    })
    if (response.isConfirmed) {
      this.$store.commit('loading')
      const res = await api.post(api.core, "contract/delete", {
        uuids: [this.$route.params.contractUuid],
      });
      this.$store.commit('stopLoading')
    }
  }

  onOrphansRecovered() {
    window.location.reload()
  }

  onAvenantsRestored() {
    window.location.reload()
  }


  hideAsset() {
    this.item = null;
  }

  async downloadInvoice(item: Invoice) {
    api.downloadPdf(
        api.core + "invoice/" + item.id + "/print",
        "Facture" + "-"
    );
  }

  async simulateWave(transaction: PaymentTransaction) {
    const res = await api.get(
        api.core,
        "payment/simulate/wave/response/" + transaction.uuid
    );

    this.loadPayments();
  }

  async simulateHub2(transaction: PaymentTransaction) {
    const res = await api.get(
        api.core,
        "payment/simulate/hub2/response/" + transaction.uuid
    );
    this.loadPayments();
  }

  openTransferModal(transaction: PaymentTransaction) {
    this.transactionToTransfer = transaction;
    (this.$refs.transferModal as any).show();
  }

  canEmitAvenant(avenant: any) {
    if (!helper.empty(avenant.deletedAt) || avenant.status !== CONSTANTS.AVENANT_STATUS.PROJET) {
      return false
    }
    if (auth.hasRole('ROLE_MANAGER')) {
      return true
    }
    if (auth.hasRole('ROLE_PARTNER')) {
      const settings = this.$store.state.settings || {}
      const branchId = (typeof avenant?.contract?.branch === 'object' ? avenant?.contract?.branch?.id : avenant?.contract?.branch)
        ?? (typeof this.contract?.branch === 'object' ? this.contract?.branch?.id : this.contract?.branch)
      // avenantType peut etre serialise soit comme un objet {id, code, ...} soit comme un entier (id direct)
      const typeId = (typeof avenant?.avenantType === 'object' ? avenant?.avenantType?.id : avenant?.avenantType)
      if (!branchId || !typeId) return false
      const key = branchId + ':' + typeId
      const allowed: any[] = settings.allowedAvenantTypes || []
      const noPayment: any[] = settings.avenantTypesNoPayment || []
      // Lenient : si la liste des types autorisés est vide, on n'applique pas de restriction.
      if (allowed.length > 0 && !allowed.includes(key)) return false
      // Pas besoin du flag "sans paiement" si l'avenant est déjà soldé.
      if (Number(avenant.invoicesBalance) >= 0) return true
      // Strict : émission sans paiement uniquement si explicitement autorisé.
      return noPayment.includes(key)
    }
    return false
  }

  isAvenantAntidated(avenant: any): boolean {
    if (!avenant?.dateEffet) return false
    const effet = new Date(avenant.dateEffet)
    effet.setHours(0, 0, 0, 0)
    const reference = avenant.dateEmission ? new Date(avenant.dateEmission) : new Date()
    reference.setHours(0, 0, 0, 0)
    return effet.getTime() < reference.getTime()
  }

  shouldGenerateAttestations(uuid: string): boolean {
    return this.attestationFlags[uuid] !== false
  }

  setAttestationFlag(uuid: string, value: boolean) {
    this.$set(this.attestationFlags, uuid, value)
  }

  canEditAvenant(avenant: any) {
    return helper.empty(avenant.deletedAt) && avenant.status === CONSTANTS.AVENANT_STATUS.PROJET && auth.hasRole('ROLE_MANAGER') && avenant.avenants
  }

  // Le renouvellement a son propre flux fonctionnel (Renouvellement.vue) qui charge
  // l'etat du contrat existant. Les autres types passent par le generateur d'avenant.
  avenantCreateRoute(avenantType: any) {
    const code = (avenantType?.code || '').toUpperCase()
    if (code.startsWith('REN')) {
      return {name: 'contract-renewal', params: {uuid: this.contract.uuid}}
    }
    return {
      name: 'avenant-generator',
      params: {
        branchSlug: this.contract.branch?.slug,
        avenantType: avenantType.code,
        contractUuid: this.contract.uuid,
      },
    }
  }

  confirmTransfer() {
    if (this.transactionToTransfer) {
      this.$store.commit("setPendingTransfer", {
        transactionUuid: this.transactionToTransfer.uuid,
        amount: this.transactionToTransfer.amount,
      });
      new Popup(
          "Transfert en attente",
          "Sélectionnez une facture non payée pour y affecter ce paiement",
          "info",
          "fad fa-info-circle",
          true
      );
    }
  }

  cancelPendingTransfer() {
    this.$store.commit("clearPendingTransfer");
    new Popup("Annulé", "Le transfert a été annulé", "warning", "fad fa-times");
  }

  async applyTransferToInvoice(invoice: Invoice) {
    if (!this.pendingTransfer) return;

    const result = await Swal.fire({
      title: "Confirmer l'affectation",
      html: `Affecter le paiement de <strong>${helper.currencyFormat(
          this.pendingTransfer.amount
      )}</strong> à la facture <strong>${invoice.number}</strong> ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Confirmer",
      cancelButtonText: "Annuler",
    });

    if (result.isConfirmed) {
      const popup = new Popup(
          "Transfert en cours",
          "Veuillez patienter...",
          "info",
          "fad fa-spinner fa-spin",
          true
      );

      try {
        const res = await api.post(api.core, "payment/transfer/apply", {
          transactionUuid: this.pendingTransfer.transactionUuid,
          invoiceId: invoice.id,
        });
        popup.hide();

        if (res && res.data && res.data.success) {
          this.$store.commit("clearPendingTransfer");
          new Popup(
              "Succès",
              "Le paiement a été transféré avec succès",
              "success",
              "fad fa-check"
          );
          this.loadPayments();
          this.loadInvoices();
        } else {
          new Popup(
              "Erreur",
              res?.data?.message || "Une erreur est survenue",
              "danger",
              "fad fa-times"
          );
        }
      } catch (error) {
        popup.hide();
        new Popup(
            "Erreur",
            "Une erreur est survenue lors du transfert",
            "danger",
            "fad fa-times"
        );
      }
    }
  }

  async loadAccesses() {
    const res = await api.post(api.core, 'contract/get/accesses/' + this.$route.params.contractUuid, this.accessFilter)
    if (res && res.data && res.data.accesses) {
      this.accesses = res.data.accesses
    }
  }

  async payWithCustomerBalance(invoice: Invoice) {
    const customerBalance = this.contract?.subscriber?.account?.balance || 0;
    const amountDue = Math.abs(invoice.balance);
    const amountToApply = Math.min(customerBalance, amountDue);

    const result = await Swal.fire({
      title: "Payer avec le solde client",
      html: `
        <div class="text-start">
          <p><strong>Solde client disponible :</strong> ${helper.currencyFormat(
          customerBalance
      )} FCFA</p>
          <p><strong>Montant dû sur la facture :</strong> ${helper.currencyFormat(
          amountDue
      )} FCFA</p>
          <hr>
          <p class="text-success"><strong>Montant à appliquer :</strong> ${helper.currencyFormat(
          amountToApply
      )} FCFA</p>
          ${
          amountToApply < amountDue
              ? `<p class="text-warning small">Reste à payer après : ${helper.currencyFormat(
                  amountDue - amountToApply
              )} FCFA</p>`
              : ""
      }
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Confirmer le paiement",
      cancelButtonText: "Annuler",
    });

    if (result.isConfirmed) {
      const popup = new Popup(
          "Paiement en cours",
          "Veuillez patienter...",
          "info",
          "fad fa-spinner fa-spin",
          true
      );

      try {
        const res = await api.post(
            api.core,
            "payment/pay-with-balance/" + invoice.id,
            {}
        );
        popup.hide();

        if (res && res.data && res.data.success) {
          new Popup("Succès", res.data.message, "success", "fad fa-check");
          this.loadInvoices();
          this.loadContract(); // Recharger pour mettre à jour le solde client
        } else {
          new Popup(
              "Erreur",
              res?.data?.message || "Une erreur est survenue",
              "danger",
              "fad fa-times"
          );
        }
      } catch (error) {
        popup.hide();
        new Popup(
            "Erreur",
            "Une erreur est survenue lors du paiement",
            "danger",
            "fad fa-times"
        );
      }
    }
  }

  canDelete() {
    if (!this.contract) {
      return false;
    }
    if (this.contract.deletedAt) {
      return false;
    }
    return true;
  }

  canAddAvenant() {
    if (!this.contract) {
      return false;
    }
    if (this.contract.deletedAt) {
      return false;
    }
    return true;
  }

  canDoActionOnAvenants() {
    if (!this.contract) {
      return false;
    }
    if (this.contract.deletedAt) {
      return false;
    }
    return true;
  }

  getItemPack(item: Item) {
    let insurerLabel = "";
    let packLabel = "";
    if (item && item.pack && item.pack.insurer) {
      return item.pack.insurer.label + " ▪ " + item.pack.label;
    }
    for (let property of item.properties) {
      if (property.model.type.code === "PACK") {
        if (property.value) {
          const value = JSON.parse(property.value);
          if (value && value.pack && value.pack.label) {
            packLabel = value.pack.label;
            if (value.pack.insurer && value.pack.insurer.label) {
              insurerLabel = value.pack.insurer.label;
            }
          }
          if (
              helper.empty(insurerLabel) &&
              value &&
              value.insurer &&
              value.insurer.label
          ) {
            insurerLabel = value.insurer.label;
          }
        }
      }
    }

    return insurerLabel + " " + packLabel;
  }

  /**
   * Releve un avenant soft-supprime. Le back restaure aussi ce qui est tombe avec lui
   * (coverages, factures, commissions, item...) : sans ca l'avenant reapparaitrait vide.
   */
  async restoreAvenant(avenant: any) {
    const response = await Swal.fire({
      title: 'Restaurer',
      html: `Restaurer l'avenant <b>AV${avenant.numero}</b> et tout ce qui a ete supprime avec lui ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Restaurer',
      cancelButtonText: 'Annuler',
      customClass: {confirmButton: 'btn btn-success', cancelButton: 'btn btn-light'},
      buttonsStyling: false,
    })
    if (!response.isConfirmed) return
    const res = await api.get(api.core, 'avenant/restore/' + avenant.uuid)
    if (res?.data?.status === 'success') {
      const detail = Object.entries(res.data.restored || {})
        .map(([type, count]) => `${count} ${type}`)
        .join(' · ')
      new Popup('Avenant restaure', detail || `AV${avenant.numero} est de nouveau actif`, 'success', 'fad fa-trash-arrow-up', true)
      this.loadAvenants()
      this.loadContract()
    } else {
      new Popup('Restauration impossible', res?.data?.message || 'Erreur inconnue', 'danger', 'fad fa-triangle-exclamation', true)
    }
  }

  async removeAvenantProject(avenant: Avenant) {
    const response = await Swal.fire({
      title: "Supprimer",
      html: "Êtes-vous sûr de vouloir supprimer ce projet  d'avenant ?",
      timer: 10000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
    });
    if (response.isConfirmed) {
      const res = await api.get(
          api.core,
          "avenant/remove/project/" + avenant.uuid
      );
      if (res && res.data) {
        this.loadAvenants();
      }
    }
  }

  async mounted() {
    const now = new Date();
    this.dateEffet = helper.reversedDateToHtml(now);
    this.userType = localStorage.getItem("userType");
    this.loadAvenants();
    await this.loadContract();
    if (this.contract) {

      // api.loadManagers().then((data: any) => {
      //   this.managers = data;
      // });
      // if (this.userType === "manager") {
      //   this.partners = await this.$store.getters.partners();
      //   this.partnerUsers = await this.$store.getters.partnerUsers();
      // }
      this.loadPaymentMethods();
    }
    // if (this.contract && this.contract.branch.id) {
    //   this.loadTypesAvenant(this.contract.branch.id);
    // }
  }

  setReplacementMethod(method: PaymentMethod) {
    this.selectedMethod = method;
  }

  getReplacedAmount() {
    let amount = 0;
    this.transactions.forEach((t: PaymentTransaction) => {
      if (this.transactionIds.includes(t.id)) {
        amount += t.amount;
      }
    });

    return amount;
  }

  toggleTransaction(transaction: PaymentTransaction) {
    const index = this.transactionIds.findIndex((t) => {
      return t.id === transaction.id;
    });

    const method = this.paymentMethods.find((m: PaymentMethod) => {
      return m.slug === transaction.method.slug;
    });
    if (method && transaction.status === "SUCCEED") {
      transaction.method = method;
      if (index > -1) {
        this.transactionIds.splice(index, 1);
      } else if (transaction.method.requireManagerValidation === true) {
        this.transactionIds.push(transaction.id);
      }
    } else {
      new Popup("Erreur", "Cette transaction n'a pas encore été payée");
    }
  }

  loadPartnersData() {
    this.$store.getters.partners(true);

    this.$store.getters.partnerUsers(true);
  }

  async replaceTransactions() {
    if (!helper.empty(this.transactionIds) && this.selectedMethod) {
      let endpoint = "payment/replace/" + this.selectedMethod.slug;
      if (!helper.empty(this.replacementNumber)) {
        endpoint += "/" + this.replacementNumber;
      }
      const res = await api.post(api.core, endpoint, this.transactionIds);
      if (res && res.data && res.data.transaction) {
        const t = new PaymentTransaction(res.data.transaction);
        this.transactions.unshift(t);

        const response = await Swal.fire({
          title: "Lien de paiement",
          html:
              "Votre lien de paiement est le suivant : <br>" +
              '<div class="fw-bolder btn btn-primary text-white my-5"><a target="_blank" class="text-white" href="' +
              res.data.url +
              '">' +
              "Payer " +
              t.amount +
              " sur " +
              this.selectedMethod.label +
              " </a></div>" +
              '<div class="fw-bolder my-5 fs-2">' +
              res.data.url +
              "</div>",
          showCancelButton: true,
          confirmButtonText: "Ok",
        });
      }
    }
  }

  async switchPartner(code: string) {
    const response = await Swal.fire({
      title: "Réattribuer ce contrat",
      html: "Êtes-vous sûr de vouloir attribuer ce contrat à ce partenaire ? <br/><br/> La commission lié à ce contrat lui sera attribué en votre nom",
      timer: 10000,
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: "Confirmer",
    });
    if (response.isConfirmed) {
      this.$store.commit("loading");
      const res = await api.get(
          api.core,
          "contract/transfer/partner/" + this.contract.uuid + "/" + code
      );
      this.$store.commit("stopLoading");
    }
  }

  async subscribeRenewalCampaign() {
    if (this.contract) {
      this.$store.commit("loading");
      const res = await api.get(
          api.core,
          "contract/subscribe/renewal/campaign/" + this.contract.uuid
      );
      this.$store.commit("stopLoading");
    }
  }

  getPartnerNameByCode(code: string) {
    if (code === "all") {
      return "Tous les partenaires";
    }
    const partner = this.partners.find((partner: Partner) => {
      return partner.code === code;
    });
    if (partner) {
      if (!helper.empty(partner.name)) {
        return partner.name;
      }
      return partner.code;
    }
    return code;
  }

  getLink(pm: PaymentMethod | null, avenant: Avenant) {
    let route = api.comparator + "avenant/payment/" + avenant.uuid;
    if (pm) {
      route += "/" + pm.slug;
    }
    return route;
  }

  async repay(transaction: PaymentTransaction, pm: PaymentMethod) {
    if (helper.empty(this.linkPhoneNumber)) {
      new Popup("Erreur", "Le contact est vide");
      return;
    }

    this.$store.commit("loading");

    const res = await api.get(
        api.core,
        "payment/repay" +
        "/" +
        transaction.id +
        "/" +
        pm.slug +
        "/" +
        this.linkPhoneNumber
    );
    this.$store.commit("stopLoading");

    if (res && res.data && res.data.url) {
      const response = await Swal.fire({
        title: "Lien de paiement",
        html:
            'Votre lien de paiement est le suivant : <br><div class="fw-bolder btn btn-primary text-white my-5"><a target="_blank" class="text-white" href="' +
            res.data.url +
            '">Payer ' +
            transaction.amount +
            " sur " +
            pm.slug +
            " </a></div>" +
            '<div class="fw-bolder my-5 fs-2">' +
            res.data.url +
            "</div>",
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        didOpen: () => {
          // Swal.showLoading()
          // const b = Swal.getHtmlContainer().querySelector('b')
          // timerInterval = setInterval(() => {
          //     b.textContent = Swal.getTimerLeft()
          // }, 100)
        },
        willClose: () => {
          // clearInterval(timerInterval)
        },
      });
      // if (response.isConfirmed) {
      //
      // }
      // this.generatedLink = res.data.url
    }
    // window.location.href = link;
  }

  async sendPaymentLink(pm: PaymentMethod | null, avenant: Avenant) {
    if (helper.empty(this.linkPhoneNumber)) {
      new Popup("Erreur", "Le contact est vide");
      return;
    }
    this.$store.commit("loading");
    const link = this.getLink(pm, avenant);
    if (pm) {
      const ref = "pm-button-" + pm.uuid;
      const refs = this.$refs as any;
      if (refs.hasOwnProperty(ref)) {
        refs[ref][0].hide();
      }
    }
    const res = await api.post(api.core, "avenant/send/payment/short", {
      uuid: avenant.uuid,
      link: link,
      contact: this.linkPhoneNumber,
      amount: this.amount,
      method: pm ? pm.slug : null,
    });
    this.$store.commit("stopLoading");
    if (res && res.data) {
      // if (res.data.url) {
      //   open(res.data.url, '_blank')
      // }

      const response = await Swal.fire({
        title: "Lien de paiement",
        html:
            "Votre lien de paiement est le suivant : <br>" +
            '<div class="fw-bolder btn btn-primary text-white my-5">' +
            '<a target="_blank" class="text-white" href="' +
            res.data.url +
            '">' +
            "Payer " +
            this.amount +
            (pm ? " sur " + pm.slug : "") +
            "</a>" +
            "</div>" +
            '<div class="fw-bolder my-2 fs-2">' +
            res.data.url +
            "</div>",
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        didOpen: () => {
          // Swal.showLoading()
          // const b = Swal.getHtmlContainer().querySelector('b')
          // timerInterval = setInterval(() => {
          //     b.textContent = Swal.getTimerLeft()
          // }, 100)
        },
        willClose: () => {
          // clearInterval(timerInterval)
        },
      });

      // const pop = new Popup(
      //     "SMS Envoyé",
      //     "Un lien de paiement à été envoyé au " + this.linkPhoneNumber,
      //     "primary",
      //     "fad fa-sms"
      // );
    }
  }

  async sendRePaymentLink(pm: PaymentMethod, transaction: PaymentTransaction) {
    console.log("object");
    if (helper.empty(this.linkPhoneNumber)) {
      new Popup("Erreur", "Le contact est vide");
      return;
    }
    this.$store.commit("loading");
  }

  async loadPaymentMethods() {
    this.isLoading = true;
    const popup = new Popup(
        "Chargement ...",
        "",
        "warning",
        "fad fa-cogs",
        true
    );
    const res = await api.get(api.core, "payment/method/list");
    this.isLoading = false;
    popup.hide();
    if (res && res.data) {
      this.paymentMethods = [];
      res.data.methods.forEach((method: PaymentMethod) => {
        this.paymentMethods.push(new PaymentMethod(method));
      });
    }
  }

  isAvenantExpired(avenant: Avenant) {
    const now = new Date();
    if (
        avenant.status === CONSTANTS.AVENANT_STATUS.PROJET &&
        avenant.source !== "Formulaire Interne"
    ) {
      let effet = new Date(avenant.dateEffet);
      effet.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      // console.log(now, effet)
      // console.log(now.getTime() + " >" + effet.getTime());
      // console.log(now.getTime() > effet.getTime())
      return now.getTime() > effet.getTime();
    }
    return false;
  }

  async loadPayments() {
    this.isLoading = true;
    const popup = new Popup(
        "Chargement ...",
        "",
        "warning",
        "fad fa-cogs",
        true
    );
    const res = await api.get(
        api.core,
        "contract/payment/list/" + this.$route.params.contractUuid
    );
    this.isLoading = false;
    popup.hide();
    if (res && res.data && res.data.transactions) {
      this.transactions = [];
      res.data.transactions.forEach((op: any) => {
        const occ = new PaymentTransaction(op);
        this.transactions.push(occ);
      });
    }
  }

  async loadInvoices() {
    this.isLoading = true;
    const popup = new Popup(
        "Chargement ...",
        "",
        "warning",
        "fad fa-cogs",
        true
    );
    const res = await api.get(
        api.core,
        "contract/invoice/list/" + this.$route.params.contractUuid
    );
    this.isLoading = false;
    popup.hide();
    if (res && res.data && res.data.invoices) {
      this.invoices = [];
      res.data.invoices.forEach((i: any) => {
        this.invoices.push(new Invoice(i));
      });
    }
  }

  async loadReceipt(uuid: string) {
    this.isLoading = true;
    const res = await api.get(api.core, "payment/receipt/" + uuid);
    this.isLoading = false;
  }

  async emitAvenant(avenant: Avenant) {
    const antidated = this.isAvenantAntidated(avenant);
    if (antidated) {
      const confirm = await Swal.fire({
        title: 'Avenant antidaté',
        html: `La date d'effet (<b>${new Date((avenant as any).dateEffet).toLocaleDateString('fr-FR')}</b>) est antérieure à aujourd'hui.<br/>Les attestations ASACI ne seront <b>pas</b> générées.<br/>Émettre tout de même ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Émettre',
        cancelButtonText: 'Annuler',
      });
      if (!confirm.isConfirmed) return;
    }
    this.$store.commit("loading");
    const config: any = {};
    if (antidated || (this.hasAsaciWorkflow && !this.shouldGenerateAttestations(avenant.uuid))) {
      config.skipWorkflows = ['asaci'];
    }
    const res = await api.post(api.core, "avenant/emit/" + avenant.uuid, { config });
    this.$store.commit("stopLoading");
    if (res?.data) {
      this.loadContract();
      this.loadAvenants();
    }
  }

  customPartnerLabel(option: any) {
    // console.log(option)
    if (typeof option === "string") {
      return option;
    }
    return option.code;
  }

  updatePartner(e: any) {
    console.log(e);
  }

  async updateManager(e: any) {
    if (e && e.uuid) {
      const u = new User(e);
      const response = await Swal.fire({
        title: "Attribuer à " + u.identifier,
        html: "Êtes-vous sûr de vouloir changer le gestionnaire de ce contrat ?",
        timer: 10000,
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonText: "Changer",
        didOpen: () => {
        },
        willClose: () => {
        },
      });
      if (response.isConfirmed) {
        this.$store.commit("loading");
        const res = await api.get(
            api.core,
            "contract/update/manager/" + this.contract.uuid + "/" + e.uuid
        );
        this.$store.commit("stopLoading");
        if (res && res.data && res.data.contract) {
          this.contract = new Contract(res.data.contract);
        }
      }
    }
  }

  itemHasChildren(item: Item) {
    // let result = false
    return item.properties.some((p: Property) => p.children.length > 0);
    // item.properties.forEach((p: Property) => {
    //     if (p.children.length > 0) {
    //         result = true
    //     }
    // })
    // return result
  }

  toggleItemExpand(item: Item, evt: Event) {
    // console.log(evt)
    // console.log(evt instanceof Event)
    let value: any = evt;
    if (evt instanceof Event) {
      value = (evt.target as any).checked as any;
    } else {
      item.expand = value;
      // console.log('hide ' + item.name)
    }
    item.properties.forEach((p: Property) => {
      p.children.forEach((c: Item) => {
        const index = this.itemList.findIndex((i: Item) => {
          return i.uuid === item.uuid;
        });
        if (index !== -1) {
          this.itemList[index].expand = item.expand;
          this.toggleItemExpand(c, value);
        }
      });
    });
  }

  previewPrintable(item: Item, printable: Printable) {
  }

  async regenerateCoveragePrintables(coverage: any) {
    this.$set(coverage, 'regenerating', true);
    try {
      const res = await api.post(api.core, `item/printable/coverage/${coverage.uuid}/regenerate`, {});
      if (res?.data?.status === 'success') {
        hydrateCollection(res.data.printables, Printable, coverage.printables);
        Swal.fire({ icon: 'success', title: 'Documents générés', timer: 1500, showConfirmButton: false });
      } else {
        Swal.fire({ icon: 'error', title: 'Échec de la génération' });
      }
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Échec de la génération' });
    } finally {
      this.$set(coverage, 'regenerating', false);
    }
  }

  async getAvenantData(avenant: Avenant) {
    this.isLoadingAvenant = true;
    const res = await api.get(api.core, "avenant/get/items/" + avenant.uuid);
    // console.log(res)
    this.isLoadingAvenant = false;
  }

  getItemByLines(item: Item, result?: Item[]) {
    if (!result) {
      result = [];
    }
    if (!result.includes(item)) {
      result.push(item);
    }
    item.properties.forEach((p: Property) => {
      p.children.forEach((c: Item) => {
        c.parentItem = item;
        c.level = item.level + 1;
        this.getItemByLines(c, result);
      });
    });
    return result;
  }

  async setAvenant(avenant: Avenant) {
    this.avenant = avenant;
    if (!this.avenant.root) {
      this.isLoadingAvenant = true;
      const res = await api.get(
          api.core,
          "avenant/get/root/" + this.avenant.uuid
      );
      if (res && res.data && res.data.root) {
        this.avenant.root = new Item(res.data.root);
      }
      this.isLoadingAvenant = false;
    }
    this.itemList = this.getItemByLines(this.avenant.root);
  }

  async payAvenant(avenant: Avenant) {
    this.amount = Math.abs(this.amount);
    if (this.amount == 0) {
      new Popup("Erreur", "Entrez un motant supérieur à 0");
      return;
    }
    if (Math.abs(avenant.invoicesBalance) < this.amount) {
      const response = await Swal.fire({
        title: "Montant supérieur",
        html:
            "Le solde est supérieur au montant dû voulez vous verser la différence " +
            helper.currencyFormat(this.amount - Math.abs(avenant.balance)) +
            " sur le compte client ?",
        timer: 10000,
        timerProgressBar: true,
      });
      if (!response.isConfirmed) {
        return;
      }
    }

    const antidated = this.isAvenantAntidated(avenant);
    if (antidated) {
      const confirm = await Swal.fire({
        title: 'Avenant antidaté',
        html: `La date d'effet (<b>${new Date((avenant as any).dateEffet).toLocaleDateString('fr-FR')}</b>) est antérieure à aujourd'hui.<br/>Les attestations ASACI ne seront <b>pas</b> générées.<br/>Poursuivre le paiement ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Payer',
        cancelButtonText: 'Annuler',
      });
      if (!confirm.isConfirmed) return;
    }

    this.$store.commit("loading");
    const config: any = {};
    if (antidated || (this.hasAsaciWorkflow && !this.shouldGenerateAttestations(avenant.uuid))) {
      config.skipWorkflows = ['asaci'];
    }
    const res = await api.post(api.core, "checkout/pay/avenant/" + avenant.uuid + "/" + this.amount, { config });
    if (res && res.data && res.data.status === "success") {
      this.loadAvenants();
    }
    this.$store.commit("stopLoading");
  }

  async loadAvenants() {
    this.isLoading = true;
    const res = await api.post(api.core, "contract/get/avenants/" + this.$route.params.contractUuid, this.avenantFilter);
    this.isLoading = false;
    if (res && res.data && res.data.avenants) {
      res.data.avenants.reverse();
      this.avenants = [...res.data.avenants]
      // this.$set(this,'avenants',res.data.avenants)
      if (helper.empty(this.currentDate)) {
        this.currentDate = new Date()
      }
    }
  }

  appendDetail(label, value, icon) {
    const data = {label, value, icon}
    const index = this.data.findIndex((i) => {
      return i.label = label
    })
    if (index !== -1) {
      this.$set(this.data, index, data)
    } else {
      this.data.push(data)
    }
  }

  onSimilarMerged(payload: {masterUuid: string, report: any}) {
    if (payload.masterUuid && payload.masterUuid !== this.$route.params.contractUuid) {
      this.$router.replace({name: 'contract-show', params: {contractUuid: payload.masterUuid}});
    } else {
      this.loadContract();
      this.loadAvenants();
    }
  }

  async loadContract() {
    this.isLoading = true;
    const res = await api.get(api.core, "contract/get/data/" + this.$route.params.contractUuid, {
      headers: {fcm: true}
    });
    this.isLoading = false;
    if (res && res.data) {
      // Redirection auto désactivée : on préfère afficher le bandeau avec bouton "Ouvrir le master"
      // if (res.data.moved) {
      //   this.$router.replace({name: 'contract-show', params: {contractUuid: res.data.moved}})
      //   return
      // }
      this.mergedTo = res.data.mergedTo || res.data.moved || null;
      this.canPromoteToMaster = !!res.data.canPromoteToMaster;
      if (res.data.contract) {
        this.contract = new Contract(res.data.contract);
        this.$store.commit('contractStore/setItemTypes', res.data.itemTypes)

        res.data.insurers.forEach((i: any) => {
          this.insurers[i.id] = i
        })

        this.appendDetail('Prime TTC', helper.currencyFormat(this.contract.primeTTC), 'fad fa-coin')
        this.linkPhoneNumber = this.contract.subscriber.mobile;
        if (res.data.authorizedAvenants) {
          this.authorizedAvenants = res.data.authorizedAvenants;
        }
      }
    } else {
      this.contractNotFound = true;
    }
  }

  async loadTypesAvenant(idBranch: number) {
    this.isLoading = true;
    const res = await api.get(api.core, "avenant/type/list/" + idBranch);
    if (res && res.data && res.data.typesAvenant) {
      // (this.$refs.dataTypeModal as any).hide()
      this.typesAvenant = [];
      res.data.typesAvenant.forEach((type: TypeAvenant) => {
        this.typesAvenant.push(new TypeAvenant(type));
      });
    }

    this.isLoading = false;
  }

  checkModeAvenant(avenant: Avenant) {
    // console.log(avenant.transactions);
    return avenant.transactions.some(
        (item) => item.status === "Réussie" && item.type === "Espèce"
    );
  }

  contractColorPseudo(contract: any) {
    if (contract.status === CONSTANTS.CONTRACT_STATUS.ONGOING) {
      return 'success'
    } else if (contract.status === CONSTANTS.CONTRACT_STATUS.TERMINATED) {
      return 'danger'
    } else if (contract.status === CONSTANTS.CONTRACT_STATUS.EXPIRED) {
      return 'danger'
    } else if (contract.status === CONSTANTS.CONTRACT_STATUS.SUSPENDED) {
      return 'warning'
    } else {
      return 'secondary'
    }
  }

  async forwardAvenant(avenant: Avenant) {
    const res = await api.post(api.core, "avenant/forward/" + avenant.uuid, {
      dateEffet: this.dateEffet,
    });
    if (res && res.data && res.data.status === "success") {
      this.dateEffet = null;
      this.loadAvenants();
    }
  }
}
</script>
<style scoped>
.filter {
  position: relative;
  /*top: 0;*/
  /*left: 0;*/
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  /*z-index: 9999;*/
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

td {
  vertical-align: middle;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.2s;
}

.slide-left-leave-from {
  transition: all 0.2s;
}

.slide-left-enter {
  opacity: 0;
  transform: translateY(50%);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-50%);
}

.modal-xl .modal-content {
  height: 100%;
}

.payment-method {
  filter: grayscale(100);
  transition: all 0.3s ease;
}

.payment-method:hover,
.payment-method.selected {
  filter: grayscale(0);
}

td {
  white-space: nowrap;
}
</style>
